import { useMemo } from 'react'
import {
  InvoiceResponse,
  InvoiceType,
  InvoiceEvent,
  isToBeInvoicedWorkspaceTab,
} from '../../../../../store/invoices/invoices.types'
import InvoiceTableActions from '../invoice-table-body/invoice-table-actions/invoice-table-actions'
import InvoiceTableCompany from '../invoice-table-body/invoice-table-company/invoice-table-company'
import InvoiceTableDocuments from '../invoice-table-body/invoice-table-documents/invoice-table-documents'
import InvoiceTableInvoiceId from '../invoice-table-body/invoice-table-invoiceid/invoice-table-invoiceid'
import InvoiceTableCell from '../invoice-table-cell/invoice-table-cell'
import { DateTime } from 'luxon'
import { Link, TableRow, styled } from '@mui/material'
import { listTableEvenRowSx } from 'components/list-table/list-table.styles'

type InvoiceTableRowProps = {
  invoice: InvoiceResponse
  handleViewInvoice: (tab?: number) => void
  isSelected: boolean
  onSelect: (selected: boolean) => void
  invoiceType: InvoiceType
  showBatchColumn?: boolean
  onBatchClick?: (batchId: number) => void
}

export const StyledTableRow = styled(TableRow)({
  ...listTableEvenRowSx,
})

const InvoiceTableRow = ({
  invoice,
  handleViewInvoice,
  isSelected,
  onSelect,
  invoiceType,
  showBatchColumn = false,
  onBatchClick,
}: InvoiceTableRowProps) => {
  const aging = useMemo(() => {
    if (isToBeInvoicedWorkspaceTab(invoiceType)) {
      return 0
    }

    const invoiceSentEvent = invoice.events.find(
      (item) => item.event === InvoiceEvent.InvoiceSent && item.createdDate
    )

    if (!invoiceSentEvent?.createdDate) {
      return 0
    }

    const givenDate = DateTime.fromISO(invoiceSentEvent.createdDate)
    const today = DateTime.now()

    return Math.round(today.diff(givenDate, 'days').days)
  }, [invoiceType, invoice.events])

  const batchLabel = invoice.batchDisplayId ?? (invoice.batchId ? `#${invoice.batchId}` : '-')

  return (
    <StyledTableRow hover>
      <InvoiceTableInvoiceId
        {...invoice}
        isSelected={isSelected}
        onSelect={onSelect}
      />
      <InvoiceTableCompany {...invoice} />
      <InvoiceTableCell value1={aging} value2={'Days'} />
      <InvoiceTableCell
        value1={`$${invoice?.totalAmount.toFixed(2)}`}
        value2={invoice?.currency}
      />
      <InvoiceTableDocuments align="left" orderId={invoice?.orderId} invoiceId={invoice?.id} invoiceType={invoiceType} />
      {showBatchColumn && (
        <InvoiceTableCell
          value1={
            invoice.batchId ? (
              <Link
                underline="none"
                sx={{ cursor: 'pointer' }}
                onClick={() => onBatchClick?.(invoice.batchId as number)}
              >
                {batchLabel}
              </Link>
            ) : (
              batchLabel
            )
          }
        />
      )}
      <InvoiceTableActions
        align="left"
        invoice={invoice}
        handleViewInvoice={handleViewInvoice}
        invoiceType={invoiceType}
      />
    </StyledTableRow>
  )
}

export default InvoiceTableRow
